import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { useState } from 'react';
import Quotation from './TabRecords/Quotation';

const ListDetail = () => {
  const [value, setValue] = useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <Box
      sx={{ backgroundColor: 'primary.light', borderRadius: '4px 4px 0 0' }}
      width={'100%'}
    >
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: '#F3F3F3' }}>
          <TabList
            onChange={handleChange}
            aria-label='lab API tabs example'
            variant='fullWidth'
            sx={{
              minHeight: '36px',
              '& .MuiButtonBase-root.MuiTab-root': {
                py: '9px',
                minHeight: '36px',
                color: '#A3AED0',
              },
              '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
                color: 'primary.main',
              },
              '& .MuiTabs-indicator': {
                top: 0,
              },
            }}
          >
            <Tab label='予約' value='1' />
            <Tab label='見積' value='2' />
            <Tab label='入金' value='3' />
            {/* <Tab label='カルテ' value='4' /> */}
            {/* <Tab label='画像' value='5' /> */}
            <Tab label='書類' value='6' />
            <Tab label='タスク' value='7' />
            <Tab label='施術' value='8' />
            <Tab label='メモ' value='9' />
          </TabList>
        </Box>
        <TabPanel value='1'>予約</TabPanel>
        <TabPanel value='2'>
          <Quotation />
        </TabPanel>
        <TabPanel value='3'>入金</TabPanel>
        {/* <TabPanel value='4' sx={{ p: 0 }}>
          <Records />
        </TabPanel>
        <TabPanel value='5'>
          <ImageManagement />
        </TabPanel> */}
        <TabPanel value='6'>書類</TabPanel>
        <TabPanel value='7'>タスク</TabPanel>
        <TabPanel value='8'>施術</TabPanel>
        <TabPanel value='9'>メモ</TabPanel>
      </TabContext>
    </Box>
  );
};

export default ListDetail;
